export default {
	'language': 'en',
	'uicolor': '#AADC6E',
	'customConfig': '',
	'toolbarCanCollapse': true,
	'toolbarStartupExpanded': true,
	'enableTabKeyTools': true,
	'forcePasteAsPlainText': false,
	'forcePasteFromWord': true,
	'ignoreEmptyParagraph': true,
	'pasteFromWordPromptCleanup': true,
	'pasteFromWordIgnoreFontFace': true,
	'pasteFromWordKeepsStructure': true,
	'pasteFromWordRemoveFontStyles': true,
	'pasteFromWordRemoveStyles': true,
	'contentsCssStatic': "",
	'extraPlugins': {
		"colorbutton":1, 
		"justify":1, 
		"stylescombo":1, 
		"font":1, 
		"maximize":1, 
		"find":1, 
		"tableresize":1, 
		"tabletools":1, 
		"sourcedialog": 1
	},
	'removePlugins' : {
		"templates":1,
		"forms":1, 
		"print":1,
		"about":1,
		"div":1,
		"flash":1, 
		"newpage":1, 
		"smiley":1,
		"language":1,
		"sourcearea":1,
		"preview":1,
		"about":1,
		"iframe":1
	},
	'tabSpaces': 5,
	'fontSize_sizes': '8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;30/30pt;36/36pt;48/48pt',
	'font_names':
		'Andale Mono/Andale Mono, monospace;'+
		'Arial/Arial, Helvetica, sans-serif;'+
		'Bitstream Vera Sans/Bitstream Vera Sans, Helvetica, sans-serif;' +
		'Bitstream Vera Serif/Bitstream Vera Serif, Times New Roman, serif;' +
		'Comic Sans MS/Comic Sans MS, cursive;' +
		'Courier New/Courier New, Courier, monospace;' +
		'Gentium Basic/Gentium Basic, Times New Roman, serif;' +
		'Gentium Book Basic/Gentium Book Basic, Times New Roman, serif;' +
		'Georgia/Georgia, serif;' +
		'Impact/Impact, serif;' +
		'Liberation Mono/Liberation Mono, Courier New, Courier, monospace;' +
		'Liberation Sans/Liberation Sans, Helvetica, sans-serif;' +
		'Liberation Serif/Liberation Serif, Times New Roman, serif;' +
		'Linux Libertine/Linux Libertine, Helvetica, sans-serif;' +
		'Souvenir Mono ITCTT/Souvenir Mono ITCTT, Courier New, Courier, monospace;' +
		'Synchro LET/Synchro LET, sans-serif;' +
		'Tahoma/Tahoma, Geneva, sans-serif;' +
		'Times New Roman/Times New Roman, Times, serif;' +
		'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
		'Verdana/Verdana, Geneva, sans-serif'
}
